import React from 'react'

const TheProblemSection = () => {
  return (
    <section className='text-center bg-black opacity-90 text-white px-6 py-20'>
      <h2 className='font-bold text-5xl md:text-6xl mb-10'>What's Wrong With Advertising?</h2>
      <p className='text-lg md:text-xl mb-6 uppercase'>Far too many people think that online ads are</p>
      <div className='grid grid-cols-1 md:grid-cols-3 items-center justify-around p-4 text-xl font-bold mb-6'>
        <div className='p-6 uppercase'>"Annoying"</div>
        <div className='p-6 uppercase'>"Unsafe"</div>
        <div className='p-6 uppercase'>"Intrusive"</div>
      </div>
      <p className='text-lg md:text-2xl font-light tracking-wider'>
        And we agree! Which is why people deserve a gold standard in advertising where their privacy is maintained, and
        are hyper-contextual with a hint of perfect timing.
      </p>
    </section>
  )
}

export default TheProblemSection
